/* Wandlie Stoov-stijl: taalkeuze footer/header en "meer reviews" in de pop-up */
(function () {
  var NAMES = {
    nl: 'Nederlands', en: 'English', de: 'Deutsch', fr: 'Français', es: 'Español',
    it: 'Italiano', pt: 'Português', pl: 'Polski', da: 'Dansk', sv: 'Svenska',
    nb: 'Norsk', fi: 'Suomi', cs: 'Čeština', tr: 'Türkçe'
  };

  function nameFor(code) {
    var key = String(code || '').toLowerCase();
    return NAMES[key] || NAMES[key.split('-')[0]] || key.toUpperCase();
  }

  function currentPath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = window.location.pathname;
    if (root !== '/' && path.indexOf(root) === 0) path = '/' + path.slice(root.length);
    return path + window.location.search;
  }

  function switchLanguage(code) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    form.style.display = 'none';
    var fields = { form_type: 'localization', utf8: '✓', _method: 'put', language_code: code, return_to: currentPath() };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function collectLanguages() {
    var seen = {};
    var list = [];
    var options = document.querySelectorAll('.wandly-language-selector [data-wandly-language-option]');
    for (var i = 0; i < options.length; i++) {
      var code = options[i].getAttribute('data-wandly-language-option');
      if (!code || seen[code]) continue;
      seen[code] = true;
      list.push({ code: code, flag: options[i].innerHTML });
    }
    return list;
  }

  function currentLanguage() {
    var input = document.querySelector('.wandly-header [data-wandly-language-input]');
    return (input && input.value) || document.documentElement.lang || 'nl';
  }

  function buildFooterSelector() {
    var target = document.querySelector('.wandly-footer-country');
    if (!target || target.getAttribute('data-sv-ready') === '1') return;
    var languages = collectLanguages();
    if (!languages.length) return;
    target.setAttribute('data-sv-ready', '1');

    var current = currentLanguage();
    var currentItem = languages.filter(function (l) { return l.code === current; })[0] || languages[0];

    var details = document.createElement('details');
    details.className = 'sv-lang';

    var summary = document.createElement('summary');
    summary.setAttribute('aria-label', 'Taal kiezen');
    summary.innerHTML = '<span class="sv-lang-flag" aria-hidden="true">' + currentItem.flag + '</span>' +
      '<span class="sv-lang-name"></span><span class="sv-lang-chev" aria-hidden="true"></span>';
    summary.querySelector('.sv-lang-name').textContent = nameFor(currentItem.code);
    details.appendChild(summary);

    var menu = document.createElement('ul');
    menu.className = 'sv-lang-menu';
    languages.forEach(function (lang) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('lang', lang.code);
      btn.setAttribute('aria-current', lang.code === currentItem.code ? 'true' : 'false');
      btn.innerHTML = '<span class="sv-lang-flag" aria-hidden="true">' + lang.flag + '</span><span></span>';
      btn.lastChild.textContent = nameFor(lang.code);
      btn.addEventListener('click', function () {
        if (lang.code === currentItem.code) { details.removeAttribute('open'); return; }
        switchLanguage(lang.code);
      });
      li.appendChild(btn);
      menu.appendChild(li);
    });
    details.appendChild(menu);

    document.addEventListener('click', function (event) {
      if (details.hasAttribute('open') && !details.contains(event.target)) details.removeAttribute('open');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.hasAttribute('open')) { details.removeAttribute('open'); summary.focus(); }
    });

    target.replaceWith(details);
  }

  // Header-taalkeuze: na het wisselen op dezelfde pagina blijven in plaats van naar de homepage
  function keepPageOnHeaderSwitch() {
    var inputs = document.querySelectorAll('.wandly-language-form input[name="return_to"]');
    for (var i = 0; i < inputs.length; i++) inputs[i].value = currentPath();
  }


  // Review-pop-up: "Lees meer reviews" laat telkens 5 extra reviews zien
  function setupReviewsMore() {
    var modal = document.querySelector('[data-wandly-reviews-modal]');
    if (!modal || modal.getAttribute('data-sv-more') === '1') return;
    var button = modal.querySelector('[data-wandly-reviews-more]');
    var wrap = modal.querySelector('[data-wandly-reviews-more-wrap]');
    if (!button) return;
    modal.setAttribute('data-sv-more', '1');
    // Pop-up direct onder <body> plaatsen zodat niets van de pagina erdoorheen komt
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    function hiddenCards() { return modal.querySelectorAll('[data-wandly-reviews-popup-card].is-hidden'); }
    function sync() {
      var show = hiddenCards().length > 0;
      if (wrap) wrap.style.setProperty('display', show ? '' : 'none', 'important');
      button.style.setProperty('display', show ? 'inline-flex' : 'none', 'important');
      button.style.setProperty('align-items', 'center', 'important');
    }
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var cards = hiddenCards();
      for (var i = 0; i < cards.length && i < 5; i++) cards[i].classList.remove('is-hidden');
      sync();
    }, true);
    sync();
    // De oorspronkelijke code verbergt de knop bij openen; daarna opnieuw goedzetten
    new MutationObserver(function () { if (modal.classList.contains('is-open')) setTimeout(sync, 30); })
      .observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    keepPageOnHeaderSwitch();
    buildFooterSelector();
    setupReviewsMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
